<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-1 border-bottom">
            <h1 class="h2">Gestion des paramètres</h1>
        </div>

        <div class="mb-3 background-alt"><br>
            <div class="row" id="divResearch">
                <div class="filter-bar ui basic segment grid ml-auto">
                    <div class="ui form">
                        <div class="row">
                            <input type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Rechercher..."
                                   class="marginResearch">
                            <button class="btn btn-custom marginResearch" @click="doFilter">Rechercher</button>
                            <button class="btn btn-light" id="marginBtnReset" @click="resetFilter">Annuler</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/parameters/"
                          :fields="fields"
                          pagination-path=""
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          :append-params="moreParams"
                          @vuetable:pagination-data="onPaginationData"
                          class="table"
                >

                    <div slot="gender-slot" slot-scope="props">
                        <button class="btn-custom btn" title="Modifier le paramètre"
                                @click="openModal(props.rowData.id)"><i class="fas fa-pencil-alt"></i></button>
                    </div>
                </vuetable>
            </div>

            <div class="row">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} paramètres"
                                              no-data-template="Aucun paramètre"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"
                    ></vuetable-pagination>
                </div>
            </div>
            <br>
        </div>

        <modal :showModal="showModal" :hideModal="hideModal" :openModal="openModal">
            <h5 slot="header">
                Modifier la propriété {{ modal.key }}
            </h5>

            <span slot="body" class="w-100">
                <textarea class="divDisplay" cols="180" v-model="modal.value" v-if="modal.type === 'text'"></textarea>
                <input class="form-control" type="number" v-model="modal.value" v-if="modal.type === 'int'"/>
                <input class="form-control" type="text" v-model="modal.value" v-if="modal.type === 'string'"/>
            </span>

            <span slot="footer">
                <button class="btn btn-success" title="Rechercher" @click="editData(modal.id)">Valider </button>
                <button class="btn btn-danger" title="Réinitialiser la rechercher" @click="hideModal">Fermer </button>
            </span>
        </modal>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import Vuetable from 'vuetable-2'
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
    import Modal from './layout/Modal'
    import Swal from 'sweetalert2'
    import Vue from 'vue'
    import FilterBar from './layout/FilterBar'
    import axios from 'axios'
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

    export default {
        components: {Vuetable, VuetablePagination, VuetablePaginationInfo, Modal, FilterBar, InfringementSearchResultModal},
        computed: {
            api_token() {
                return api_token;
            }
        },
        data() {
            return {
                showModal: false,
                map: '',
                filterText: '',
                moreParams: {},
                modal: {
                    id: '',
                    key: '',
                    value: '',
                    type: '',
                },
                fields: [
                    {
                        name: 'key',
                        title: 'Paramètre'
                    },
                    {
                        name: 'value',
                        title: 'Valeur',
                        formatter: (value) => (value.length < 325) ? value : value.substring(0, 325) + '...'
                    },
                    {
                        name: 'gender-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                }
            }
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            openModal(data) {
                axios.get('/api/parameters/' + data)
                    .then(result => {
                        this.modal.id = result.data.id;
                        this.modal.key = result.data.key;
                        this.modal.value = result.data.value;
                        this.modal.type = result.data.type;
                    });
                this.showModal = true;
            },

            hideModal() {
                this.showModal = false;
            },

            editData(id) {
                axios.put('/api/parameters/' + id, {
                    value: this.modal.value,
                })
                    .then(result => {
                        Swal(
                            'Propriété modifiée ',
                        );
                        this.showModal = false;
                        this.$refs.vuetable.reload();
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            doFilter() {
                this.moreParams = {
                    'filter': this.filterText
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            resetFilter() {
                this.moreParams = {};
                this.filterText = '';
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            }
        },
    }
</script>

<style>
    .divDisplay {
        overflow: scroll;
        height: 400px;
        background-color: rgba(211, 211, 211, 0.5);
        color: black;
    }

    textarea {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        white-space: nowrap;
    }

    .marginResearch {
        margin-right: 10px;
    }

    #marginBtnReset {
        margin-right: 15px;
    }

    #divResearch {
        padding-right: 15px;
        padding-left: 15px;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Parameter.vue